export const LogoMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="110"
      height="16"
      viewBox="0 0 110 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4692 0.316275C24.9311 1.43056 22.1941 5.6831 23.3434 9.83359C23.9367 11.9763 25.3886 13.9069 27.1721 14.9249C30.1916 16.648 34.3792 16.2687 37.2599 14.0108L38.1367 13.3235H39.9533H41.7698V14.5679V15.8123H43.9433H46.1168V7.99025V0.168187L43.707 0.17192L41.2973 0.175474L37.9196 5.428C33.9437 11.6105 33.9189 11.6346 31.5464 11.6346C30.2275 11.6346 30.0037 11.5822 29.2645 11.099C26.8614 9.528 27.0889 6.02123 29.6735 4.79832C31.3096 4.02411 32.808 4.21219 34.6976 5.42906L35.9197 6.21589L37.053 4.56988L38.1864 2.92369L37.2849 2.14023C35.8084 0.857416 33.3691 -0.0289645 31.3961 0.000723839C31.0204 0.00623484 30.1532 0.148278 29.4692 0.316275ZM84.9168 0.312716C80.0312 1.94788 77.9212 6.82637 80.0396 11.5902C80.1658 11.8739 80.0182 11.9013 78.3648 11.9013H76.5515L76.5018 6.07918L76.4519 0.257075L74.2311 0.20694L72.0103 0.156987V7.98456V15.8123H76.7354H81.4605V14.7457C81.4605 14.159 81.51 13.679 81.5705 13.679C81.631 13.679 82.0458 13.9606 82.4924 14.3048C84.8571 16.1273 88.5241 16.4646 91.4777 15.1311C92.8039 14.5323 94.6601 12.803 95.3159 11.5553L95.8247 10.587V13.1997V15.8123H98.089H100.353L100.404 12.0659L100.455 8.31967L103.196 12.0616L105.936 15.8036L107.968 15.8079L110 15.8123V7.99025V0.168187H107.736H105.471L105.42 3.91087L105.369 7.65355L102.707 3.95531L100.046 0.257075H97.9824H95.9192L95.8247 2.73347L95.7302 5.20986L95.2577 4.2513C94.5785 2.87284 93.0453 1.50469 91.3104 0.728175C89.9804 0.132809 89.7207 0.08019 87.8866 0.0334353C86.3317 -0.00620834 85.6889 0.0542321 84.9168 0.312716ZM0 7.9675V15.8123H3.4873C5.40531 15.8123 7.42519 15.7224 7.97613 15.6123C9.94517 15.2189 12.0783 13.8653 12.9724 12.4417C13.159 12.1445 13.3784 11.9013 13.4601 11.9013C13.5415 11.9013 13.6082 12.7813 13.6082 13.8568V15.8123H18.1443H22.6804V13.9457V12.0791H20.3179H17.9553V11.0124V9.94577H20.3179H22.6804V8.07914V6.21251H20.3179H17.9553V5.05698V3.90145H20.3179H22.6804V2.03482V0.168187H18.1504H13.6202L13.567 2.21081L13.5137 4.25344L12.7207 3.28866C11.7399 2.09562 10.3052 1.16425 8.69416 0.675198C7.67562 0.366048 6.82794 0.286941 3.73282 0.212631L0 0.122854V7.9675ZM46.6838 2.1237V4.07922H48.1959H49.7079V9.94577V15.8123H51.8814H54.055V9.94577V4.07922H55.6615H57.268V2.1237V0.168187H51.9759H46.6838V2.1237ZM57.7721 0.286761C57.7027 0.351827 57.646 3.87176 57.646 8.10883V15.8123H59.9141H62.1821V12.879V9.94577H64.4502H66.7182V12.879V15.8123H68.9863H71.2543V7.99025V0.168187H68.9863H66.7182V3.19035V6.21251H64.4502H62.1821V3.19035V0.168187H60.0402C58.8619 0.168187 57.8413 0.221518 57.7721 0.286761ZM8.14983 4.57592C9.51972 5.24916 10.2563 6.35331 10.3602 7.89034C10.4487 9.19574 10.0482 10.1045 9.00507 10.966C8.14718 11.6745 7.2462 11.9392 5.5979 11.9672L4.25258 11.9902L4.20174 8.0347L4.15089 4.07922H5.64497C6.91337 4.07922 7.29156 4.15424 8.14983 4.57592ZM89.6052 4.67068C91.9868 5.85323 92.3781 8.99593 90.3573 10.713C87.9607 12.7496 84.1636 11.5093 83.6561 8.52411C83.5151 7.69533 83.9162 6.39189 84.5543 5.60488C85.6312 4.27691 87.949 3.84811 89.6052 4.67068ZM41.7698 8.25692V9.59022H40.8045C40.0186 9.59022 39.8597 9.54009 39.9495 9.32001C40.095 8.96339 41.57 6.92361 41.6822 6.92361C41.7304 6.92361 41.7698 7.5236 41.7698 8.25692Z"
        fill="#007DBC"
      />
    </svg>
  )
}

export const IconMyAccount = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64124 15.6412C5.53204 14.7504 6.74022 14.25 8 14.25H16C17.2598 14.25 18.468 14.7504 19.3588 15.6412C20.2496 16.532 20.75 17.7402 20.75 19V21C20.75 21.4142 20.4142 21.75 20 21.75C19.5858 21.75 19.25 21.4142 19.25 21V19C19.25 18.138 18.9076 17.3114 18.2981 16.7019C17.6886 16.0924 16.862 15.75 16 15.75H8C7.13805 15.75 6.3114 16.0924 5.7019 16.7019C5.09241 17.3114 4.75 18.138 4.75 19V21C4.75 21.4142 4.41421 21.75 4 21.75C3.58579 21.75 3.25 21.4142 3.25 21V19C3.25 17.7402 3.75044 16.532 4.64124 15.6412Z"
        fill="#15181B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.75C10.2051 3.75 8.75 5.20507 8.75 7C8.75 8.79493 10.2051 10.25 12 10.25C13.7949 10.25 15.25 8.79493 15.25 7C15.25 5.20507 13.7949 3.75 12 3.75ZM7.25 7C7.25 4.37665 9.37665 2.25 12 2.25C14.6234 2.25 16.75 4.37665 16.75 7C16.75 9.62335 14.6234 11.75 12 11.75C9.37665 11.75 7.25 9.62335 7.25 7Z"
        fill="#15181B"
      />
    </svg>
  )
}

export const IconCloseMenu = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z"
        fill="#15181B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
        fill="black"
      />
    </svg>
  )
}

export const ChevronBlue = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z"
        fill="#3643BA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303L12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303C11.1768 19.2374 11.1768 18.7626 11.4697 18.4697L17.9393 12L11.4697 5.53033C11.1768 5.23744 11.1768 4.76256 11.4697 4.46967Z"
        fill="#3643BA"
      />
    </svg>
  )
}

export const ChevronBlack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46967 5.96967C8.76256 5.67678 9.23744 5.67678 9.53033 5.96967L15.5303 11.9697C15.8232 12.2626 15.8232 12.7374 15.5303 13.0303L9.53033 19.0303C9.23744 19.3232 8.76256 19.3232 8.46967 19.0303C8.17678 18.7374 8.17678 18.2626 8.46967 17.9697L13.9393 12.5L8.46967 7.03033C8.17678 6.73744 8.17678 6.26256 8.46967 5.96967Z"
        fill="#15181B"
      />
    </svg>
  )
}

export const IconCategoryHighLight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_1900_12583)">
        <path
          d="M7.99958 15.8333C9.32566 15.8333 10.5974 15.3065 11.5351 14.3689C12.4728 13.4312 12.9996 12.1594 12.9996 10.8333C12.9996 10.256 12.8462 9.702 12.6662 9.18667C11.5549 10.2847 10.7109 10.8333 10.1329 10.8333C12.7962 6.16667 11.3329 4.16667 7.33291 1.5C7.66624 4.83333 5.46891 6.34933 4.57424 7.19133C3.84446 7.87779 3.33773 8.76765 3.11976 9.74555C2.90179 10.7235 2.98263 11.7443 3.35181 12.6757C3.72098 13.6071 4.36145 14.4061 5.19018 14.9691C6.01891 15.5322 6.99768 15.8332 7.99958 15.8333ZM8.47291 3.99C10.6336 5.82333 10.6442 7.248 8.97491 10.1727C8.46758 11.0613 9.10958 12.1667 10.1329 12.1667C10.5916 12.1667 11.0556 12.0333 11.5456 11.77C11.4003 12.3187 11.1297 12.8261 10.755 13.2524C10.3803 13.6787 9.91178 14.0122 9.38629 14.2266C8.8608 14.441 8.29271 14.5305 7.72675 14.4881C7.16078 14.4456 6.6124 14.2724 6.12478 13.9819C5.63716 13.6915 5.22361 13.2919 4.9167 12.8145C4.60979 12.3371 4.41789 11.7949 4.35612 11.2307C4.29435 10.6665 4.36439 10.0957 4.56073 9.56322C4.75707 9.03071 5.07435 8.55105 5.48757 8.162C5.57157 8.08333 5.99757 7.70533 6.01624 7.68867C6.29891 7.43533 6.53157 7.21067 6.76157 6.96467C7.58157 6.086 8.17091 5.11133 8.47224 3.99H8.47291Z"
          fill="#007DBC"
        />
      </g>
      <defs>
        <clipPath id="clip0_1900_12583">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z"
        fill="#15181B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4697 4.46967C11.7626 4.17678 12.2374 4.17678 12.5303 4.46967L19.5303 11.4697C19.8232 11.7626 19.8232 12.2374 19.5303 12.5303L12.5303 19.5303C12.2374 19.8232 11.7626 19.8232 11.4697 19.5303C11.1768 19.2374 11.1768 18.7626 11.4697 18.4697L17.9393 12L11.4697 5.53033C11.1768 5.23744 11.1768 4.76256 11.4697 4.46967Z"
        fill="#15181B"
      />
    </svg>
  )
}
